module.exports = __webpack_public_path__ + "static/media/giphy-8.d62a5e40.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/giphy-8.gif
// module id = 179
// module chunks = 0